import React from 'react';

const SuccessModel = ({ title, SuccessModel }) => {
  return (
    <div className="success-model">
      <button type="button" className="d-none btn btn-primary" data-bs-toggle="modal" data-bs-target="#successmodel" ref={SuccessModel}>
      </button>

      <div className="modal fade" id="successmodel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="staticBackdropLabel">{title}</h5>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Ok</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModel;
